import { cn } from "@/lib/utils";

interface NeonUpvoteIconProps {
  className?: string;
  isActive?: boolean;
}

export function NeonUpvoteIcon({ className, isActive = false }: NeonUpvoteIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        "transition-all duration-300",
        isActive ? "drop-shadow-[0_0_8px_#38bdf8]" : "drop-shadow-[0_0_2px_rgba(148,163,184,0.3)]",
        className
      )}
    >
      {/* Triangle top */}
      <path
        d="M12 3L20 13H4L12 3Z"
        stroke={isActive ? "#38bdf8" : "#64748b"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="transition-colors duration-300"
        fill="none"
      />
      
      {/* Curved stem with teardrop base */}
      <path
        d="M8 13C8 13 8 16 8 17.5C8 19.433 9.567 21 11.5 21H12.5C14.433 21 16 19.433 16 17.5C16 16 16 13 16 13"
        stroke={isActive ? "#38bdf8" : "#64748b"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="transition-colors duration-300"
        fill="none"
      />
      
      {/* Inner glow effect when active */}
      {isActive && (
        <>
          <path
            d="M12 3L20 13H4L12 3Z"
            stroke="#38bdf8"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            opacity="0.6"
          />
          <path
            d="M8 13C8 13 8 16 8 17.5C8 19.433 9.567 21 11.5 21H12.5C14.433 21 16 19.433 16 17.5C16 16 16 13 16 13"
            stroke="#38bdf8"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            opacity="0.6"
          />
        </>
      )}
    </svg>
  );
}
